<template>

    <AjanlatBase :titleExtra="titleExtra"
                 v-if="cascoPartnerKedvezmeny || lakasPartnerKedvezmeny || balesetPartnerKedvezmeny">

        <v-form slot="biztositoi-adatok">

            <v-layout row wrap>
                <BnFormField v-if="cascoPartnerKedvezmeny" :attributes="uniqa_egyuttkot_azon_casco" />
                <BnFormField v-if="lakasPartnerKedvezmeny" :attributes="uniqa_egyuttkot_azon_lakas" />
                <BnFormField v-if="balesetPartnerKedvezmeny" :attributes="uniqa_egyuttkot_azon_baleset" />
            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';

export default {
    name: 'AjanlatAdatokB6_V0',
    mixins: [offerData],
    components: {
        BnFormField,
        AjanlatBase,
    },
    computed: {
        cascoPartnerKedvezmeny() {
            return (parseInt(this.$store.getters.tarifaData.casco_biztosito, 10) === 6
                || this.kedvezmenyek.casco === true)
                && !this.egyuttkotve;
        },
        lakasPartnerKedvezmeny() {
            return parseInt(this.$store.getters.tarifaData.lbiztosito, 10) === 10
                || this.kedvezmenyek.lakas_egyutt === true;
        },
        balesetPartnerKedvezmeny() {
            return this.kedvezmenyek.baleset_egyutt === true;
        },
    },
    data() {
        return {
            uniqa_egyuttkot_azon_casco: {
                type: 'text',
                label: 'Uniqa CASCO partner kedvezmény',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa_egyuttkot_azon_casco',
                path: 'tarifaData.uniqa_egyuttkot_azon_casco',
                mask: '!V',
            },
            uniqa_egyuttkot_azon_lakas: {
                type: 'text',
                label: 'Uniqa LAKÁS partner kedvezmény',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa_egyuttkot_azon_lakas',
                path: 'tarifaData.uniqa_egyuttkot_azon_lakas',
                mask: '!V',
            },
            uniqa_egyuttkot_azon_baleset: {
                type: 'text',
                label: 'Uniqa BALESET partner kedvezmény',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa_egyuttkot_azon_baleset',
                path: 'tarifaData.uniqa_egyuttkot_azon_baleset',
                mask: '!V',
            },
        };
    },
};
</script>
